const isDebugMode = (): boolean => {
  try {
    return localStorage.getItem('curve_debug') === 'true';
  } catch {
    return false;
  }
};

export const debugLog = (...args: unknown[]): void => {
  if (isDebugMode()) {
    // eslint-disable-next-line no-console
    console.log('[Curve]', ...args);
  }
};

export const debugError = (...args: unknown[]): void => {
  if (isDebugMode()) {
    // eslint-disable-next-line no-console
    console.error('[Curve]', ...args);
  }
};
